import React, { useEffect, useState } from 'react';

import EventCreation from './Events/Event_Creation';
import EventList from './Events/Event_list';

const Events = ({ editEventFromSubflow, eventDetails, createTask, toolTipData, eventCreation }) => {
  const [isEventCreation, setIsEventCreation] = useState(eventCreation);
  const [eventName, setEventName] = useState('');
  const [selectedOption, setSelectedOption] = useState([]);
  const [eventCalloutName, setEventCalloutName] = useState('');
  const [secEventId, setSecEventId] = useState(0);
  const [primaryEventId, setPrimaryEventId] = useState(0);
  const [primaryEventSearchText, setPrimaryEventSearchText] = useState('');
  const [selectedEventSearchText, setSelectedEventSearchText] = useState('');
  const [isEditingEventFromSubflow, setIsEditingeventFromSubflow] = useState(editEventFromSubflow);

  useEffect(() => {
    console.log("isEventCreation", isEventCreation);
    console.log("handle subflow canvas click triggered in event page", editEventFromSubflow, eventDetails, eventCreation);
    if (isEditingEventFromSubflow) {
      handleEventEditClick(eventDetails.primaryEventName, eventDetails.selectedEventName, eventDetails.eventId, eventDetails.primaryEventId);
    }
  })

  useEffect(() => {
    setIsEventCreation(eventCreation);
  }, [eventCreation]);

  const handleBackClick = () => {
    setPrimaryEventSearchText('');
    setSelectedEventSearchText('');
    setIsEditingeventFromSubflow(false);
    setIsEventCreation(false);
  }
  const handleSelectChange = (selected) => {
    setSelectedOption(selected);
  };
  const handleInputCalloutName = (event) => {
    setEventCalloutName(event.target.value);
  }

  const handleEventEditClick = (primaryEventName, secondaryEventCalloutname, eventId, primaryEventId) => {    
    setEventName(primaryEventName);
    setEventCalloutName(secondaryEventCalloutname);
    setSecEventId(eventId);
    setPrimaryEventId(primaryEventId);
    setPrimaryEventSearchText('');
    setSelectedEventSearchText('');
    setIsEventCreation(true);

  }


  const handleEventSearchClear = (eventType) => {
    switch (eventType) {
      case 'primaryEvent':
        setPrimaryEventSearchText('');
        break;
      case 'selectedEvent':
        setSelectedEventSearchText('');
        break;
      default:
        console.log('no event search to clear');
    }
  }
  const handleSearchChange = (eventType, event) => {
    switch (eventType) {
      case 'primaryEvent':
        setPrimaryEventSearchText(event.target.value);
        break;
      case 'selectedEvent':
        setSelectedEventSearchText(event.target.value);
        break;
      default:
        console.log('no event search to clear');
    }
  }


  return isEventCreation ? (
    <EventCreation handleEventEditClick={handleEventEditClick} eventCalloutName={eventCalloutName} primaryEventSearchText={primaryEventSearchText} selectedEventSearchText={selectedEventSearchText} eventSearchClear={handleEventSearchClear} handleSearchChange={handleSearchChange} toolTipData={toolTipData} />
  ) : (
    <EventList handleEventEditClick={handleEventEditClick} eventCalloutName={eventCalloutName} primaryEventSearchText={primaryEventSearchText} selectedEventSearchText={selectedEventSearchText} eventSearchClear={handleEventSearchClear} handleSearchChange={handleSearchChange} toolTipData={toolTipData} />
  )
};

export default Events;